// Display labels only. API enums, template keys and stored contact data stay intact.
const labels: Record<string, string> = {
    all: '全部', unread: '未读', read: '已读', inbound: '收到', outbound: '发出',
    draft: '草稿', approved: '已审核', queued: '等待处理', running: '进行中', paused: '已暂停',
    completed: '已完成', cancelled: '已取消', failed: '发送失败', uncertain: '结果不确定',
    sent: '已发送', skipped: '已跳过', dry_run: '模拟完成', discovered: '已发现', contacted: '已联系',
    replied: '已回复', interested: '有意向', negotiating: '洽谈中', converted: '已转化', bounced: '硬退信',
    not_interested: '暂无意向', rejected: '已拒绝', inactive: '未启用', active: '正常', error: '异常',
    not_generated: '未生成', generating: '生成中', sending: '发送中', pending: '等待处理',
    valid: '格式有效', invalid: '格式无效', suspicious: '需检查', blank: '空白', duplicate: '重复邮箱',
    suppressed: '已排除', invalid_recipient: '收件邮箱无效', mailbox_full: '邮箱已满',
    rate_limited: '发送限流', sender_auth: '发件账号授权异常', provider_policy: '服务商策略限制',
    connection: '连接异常', configuration: '配置异常', unknown: '未知原因',
    smtp_bounce: '硬退信自动排除', imap_dsn: 'SpaceMail 退信通知', outlook_dsn: 'Outlook 退信通知',
    manual: '手动排除', manual_recipient_review: '联系人审核后排除', unsubscribe: '收件人退订',
    legacy_bounce: '历史硬退信记录', campaigns: '获客活动', leads: '联系人', templates: '邮件模板',
    africa: '非洲', asia: '亚太地区',
    internal: '内部', external: '对外', ready: '就绪', disabled: '未启用', enabled: '已启用',
    us: '北美洲', lat: '拉丁美洲', eu: '欧洲', ae: '亚太地区与中东', af: '非洲', global: '全部地区',
    'Super Admin (All Regions)': '超级管理员（全部地区）', 'Local safe preview': '本地示例预览',
    'North America': '北美洲', 'Latin America': '拉丁美洲', Europe: '欧洲', Africa: '非洲',
    'Asia-Pacific & Middle East': '亚太地区与中东',
    'Excluded after contact review': '联系人审核后手动排除',
    'Recipient address does not exist': '收件邮箱不存在',
    'fetch failed': '连接邮件服务失败，请检查本机网络',
    'Microsoft Graph result was uncertain; review before resuming': 'Microsoft 未返回明确发送结果，任务已暂停；结果不明的邮件不会自动重发。',
    'Recipient is on the do-not-send list.': '该邮箱已在排除名单中。',
};

export function zh(value: string | null | undefined): string {
    if (value?.startsWith('{')) {
        try {
            if (JSON.parse(value)?.error?.code === 'ErrorAccountSuspend') {
                return '发件账号已被 Microsoft 暂停，需要登录邮箱完成验证；该账号已停用，这封邮件保留为发送失败。';
            }
        } catch { /* Keep the original diagnostic if its format is unknown. */ }
    }
    return value ? labels[value] || value : '—';
}

export function countryLabel(code: string, fallback: string): string {
    try {
        const DisplayNames = (Intl as any).DisplayNames;
        return DisplayNames ? new DisplayNames(['zh-CN'], { type: 'region' }).of(code.toUpperCase()) || fallback : fallback;
    } catch { return fallback; }
}
